export type DocumentsModalItem = {
  id: number | string;
  title: string;
  href: string;
  downloadLabel?: string;
};

export const DOCUMENTS_MODAL_EVENT = 'mosprom:open-documents-modal';

export const openDocumentsModal = (items?: DocumentsModalItem[]): void => {
  window.dispatchEvent(new CustomEvent(DOCUMENTS_MODAL_EVENT, {
    detail: items && items.length ? items : null,
  }));
};
